import React, { createContext, useContext, useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../utils/firebase";
import INFO_FALLBACK from "../data/user";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
	const [data, setData] = useState(INFO_FALLBACK);

	useEffect(() => {
		if (!db) return;

		getDoc(doc(db, "portfolio", "main"))
			.then((snap) => {
				if (snap.exists()) {
					const firestoreData = { ...INFO_FALLBACK, ...snap.data() };
					setData(firestoreData);
					console.log("DataContext: Loaded portfolio data from Firestore", firestoreData);
				} else {
					console.warn("DataContext: No document found at portfolio/main, using fallback");
				}
			})
			.catch((err) => {
				console.warn("DataContext: Firestore fetch failed, using fallback", err);
			});
	}, []);

	return (
		<DataContext.Provider value={{ data }}>
			{children}
		</DataContext.Provider>
	);
};

export const usePortfolioData = () => useContext(DataContext);
